import React from 'react'

import {
  Box,
  Text,
  Space,
  FontWeight,
  FontFamily,
  Image,
  Display,
} from '@gousto-internal/citrus-react'

type OrderedRecipeProps = {
  name: string
  crops: { url: string; width: number }[]
}

export const OrderedRecipe = ({ name, crops }: OrderedRecipeProps) => (
  <>
    <Box display={Display.Flex} paddingBottom={2}>
      <Box>
        <Image
          width={['60px', '80px']}
          height={['60px', '80px']}
          src={crops[0].url}
          alt={`Image of ${name}`}
        />
      </Box>
      <Space size={4} direction="horizontal" />
      <Box>
        <Text fontWeight={FontWeight.Bold} fontFamily={FontFamily.Bold} size={2}>
          {name}
        </Text>
      </Box>
    </Box>
  </>
)
